import CustomerNotesTable from "./CustomerNotesTable";
export default CustomerNotesTable;
